import Ellipse from "../../../shapes/shapes/Ellipse";
import Rectangle from "../../../shapes/shapes/Rectangle";
import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class MoveAction extends AbstractProvidedClass {
    anchor;
    movedX = 0;
    movedY = 0;
    initialX;
    initialY;
    initialMouseX;
    initialMouseY;

    constructor(provider, mainElement, elements) {
        super(provider);

        this.mainElement = mainElement;
        this.selectedElements = elements;

        if (this.settings.snapToGrid) {
            this.setAnchor();
            this.initialMouseX = this.view.currentX;
            this.initialMouseY = this.view.currentY;
            if (this.mainElement instanceof Rectangle) {
                this.initialX = this.anchor.realX;
                this.initialY = this.anchor.realY;
            } else {
                this.initialX = this.anchor.currentX;
                this.initialY = this.anchor.currentY;
            }
            this.diffX = this.view.currentX - this.initialX;
            this.diffY = this.view.currentY - this.initialY;
        }
    }

    update() {
        let moveX = this.p.movedX / this.view.scale;
        let moveY = this.p.movedY / this.view.scale;
        if (this.anchor) {
            let projectedX = this.view.currentX - this.diffX;
            let snappedRelProjectedX = Math.round(projectedX / this.grid.minorSize) * this.grid.minorSize;
            let snappedProjectedX = Math.round(snappedRelProjectedX / this.view.scale);
            let shapeX = Math.round((this.mainElement instanceof Rectangle
                ? this.anchor.realX
                : this.anchor.currentX) / this.view.scale);
            moveX = snappedProjectedX - shapeX;

            let projectedY = this.view.currentY - this.diffY;
            let snappedRelProjectedY = Math.round(projectedY / this.grid.minorSize) * this.grid.minorSize;
            let snappedProjectedY = Math.round(snappedRelProjectedY / this.view.scale);
            let shapeY = Math.round((this.mainElement instanceof Rectangle
                ? this.anchor.realY
                : this.anchor.currentY) / this.view.scale);
            moveY = snappedProjectedY - shapeY;
        }

        if (moveX != 0 || moveY != 0) {
            this.movedX += moveX;
            this.movedY += moveY;
            this.selectedElements.map((e) => e.move(moveX, moveY));
        }
    }

    finish() {
        this.actions.finish();
    }

    undo() {
        this.selectedElements.map((e) => e.move(-this.movedX, -this.movedY));
    }

    redo() {
        this.selectedElements.map((e) => e.move(this.movedX, this.movedY));
    }

    setAnchor() {
        if (this.mainElement instanceof Ellipse) {
            this.anchor = this.mainElement;
        } else {
            this.anchor = this.mainElement.getClosestCoordinate();
        }
    }
}
